import { useNumericParams } from '@domain-group/react-hooks'

import useReduxAction from '@hooks/useReduxAction'

import { ModuleState } from '@redux/modules/module'

import defaultRequestOptions from '@sections/Client/packs/AgencyAdmin/defaultRequestOptions'

import AgencyEditRoutes from './routes'

const AgencyEdit = () => {
  const { agencyId } = useNumericParams()

  useReduxAction(
    'agencies',
    'loadAgency',
    {
      ...defaultRequestOptions.agency,
      entityId: agencyId,
    },
    [agencyId],
    {
      dispatchAction: (action, requestOptions) => action(agencyId, requestOptions),
      shouldPerformFn: ({ loading }: ModuleState) => !!agencyId && !loading,
      skipLoadedForKeysCheck: true,
    },
  )

  return (
    <AgencyEditRoutes />
  )
}

export default AgencyEdit
